import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['target']

  add() {
    const index = new Date().getTime()
    const templateName = event.currentTarget.dataset.templateName
    const template = this.element.querySelector(`template#${templateName}`)
    const html = template.innerHTML.split('NEW_RECORD').join(index)

    this.targetTarget.insertAdjacentHTML('beforeend', html)
  }

  delete(event) {
    const signature = event.currentTarget.parentElement

    signature.querySelector('input.delete').value = '1'
    signature.style.display = 'none'
  }
}
